// onResponse sees the raw response before its body is parsed, so a caller can read its headers (the x-tsx-mpt-renew
// signal, MPH-1410) although this returns only the parsed JSON.
const fetchWithTimeout = async (
  url: string,
  options: object,
  tm: number,
  onResponse?: (response: Response) => void
) => {
  const controller = new AbortController();
  const { signal } = controller;

  const timeout = setTimeout(() => {
    controller.abort();
  }, tm);

  const req = await fetch(url, {
    ...options,
    signal,
  });

  clearTimeout(timeout);

  onResponse?.(req);

  const result = await req.json();

  return result;
};

export default fetchWithTimeout;
